import { getStoredUTMParams } from '@/utils/googleAds/utmTracking';

export interface TrafficSourceResult {
  sourceName: string;
  utmData: Record<string, string>;
}

export const resolveTrafficSource = (): TrafficSourceResult => {
  const utmParams = getStoredUTMParams();
  const referrer = getStoredReferrer();

  const utmData: Record<string, string> = {};
  Object.entries(utmParams).forEach(([key, value]) => {
    if (value) utmData[key] = value;
  });

  const utmSource = (utmParams.utm_source || '').toLowerCase();
  const utmMedium = (utmParams.utm_medium || '').toLowerCase();
  const gclid = utmParams.gclid;
  const referrerLower = referrer.toLowerCase();

  // Google Ads: gclid present OR utm_source=google + utm_medium=cpc
  if (gclid || (utmSource === 'google' && utmMedium === 'cpc')) {
    return { sourceName: 'Google Ads', utmData };
  }

  // Google Organic: utm_source=google + utm_medium=organic OR referrer contains google without gclid
  if (
    (utmSource === 'google' && utmMedium === 'organic') ||
    (referrerLower.includes('google') && !gclid && !utmSource)
  ) {
    return { sourceName: 'Google Organico', utmData };
  }

  // Instagram (includes l.instagram.com and lm.facebook.com link shim)
  if (utmSource === 'instagram' || referrerLower.includes('instagram') || referrerLower.includes('lm.facebook.com')) {
    return { sourceName: 'Instagram', utmData };
  }

  // Blog TaxHealth
  if (utmSource === 'blog' || referrerLower.includes('/blog/')) {
    return { sourceName: 'Blog TaxHealth', utmData };
  }

  // Other UTM source present
  if (utmSource) {
    return { sourceName: utmSource, utmData };
  }

  // Direct access
  return { sourceName: 'Direto', utmData };
};

export const getStoredReferrer = (): string => {
  if (typeof window === 'undefined') return '';
  try {
    return localStorage.getItem('taxhealth_referrer') || '';
  } catch {
    return '';
  }
};

